<template>
    <div class="h3 font-weight-bold">
        {{ $t("sidebar.section." + section) }}
    </div>
</template>

<script>
    export default {
        name: "TitleSection",
        props: {
            section: {
                type: String,
                required: true,
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/TitleSection.vue